Vue.component('global-search', require('@RESOURCES/js/components/Search/GlobalSearch.vue').default);